import Panel from "@scene/objects/panel";
import { initState as initDimensionState } from "@reducers/selectors/dimension";
import { APP_TYPES } from "@config";

export default {
  type: Panel.types.SQUARE,
  position: Panel.positions.VERTICAL_X,
  isClosed: false,
  width: initDimensionState[APP_TYPES.SAFETY_BARRIER].basePlate.lx,
  height: initDimensionState[APP_TYPES.SAFETY_BARRIER].basePlate.ly,
  topHeight: 40,
  depth: initDimensionState[APP_TYPES.SAFETY_BARRIER].basePlate.tfix,
  dpp: {
    active: true,
    value: initDimensionState[APP_TYPES.SAFETY_BARRIER].basePlate.dpp
  },
  dy: {
    value: initDimensionState[APP_TYPES.SAFETY_BARRIER].basePlate.spacing.dy,
    isCustom: true
  },
  lyh: {
    active: false,
    value: initDimensionState[APP_TYPES.SAFETY_BARRIER].basePlate.lyh
  },
  disableEdgeDistance: false,
  dpl: {
    active: false,
    value: initDimensionState[APP_TYPES.SAFETY_BARRIER].basePlate.dpl
  },
  color: 0x98cbea,
  // VladP: The vertices object is necessary to create the panel geometry
  vertices: { 
    count: 4,
    positions: []
  }
};



// WEBPACK FOOTER //
// ./src/reducers/options/panel/defaults/safetyBarrier.js